import React from 'react';
import { useTranslation } from 'react-i18next';
import images from '../../data/images.json';
import CountdownTimer from '../../components/CountdownTimer/CountdownTimer';
import './Events.css';

const Events: React.FC = () => {
  const { t } = useTranslation();

  // Target date: January 1, 2026, 10 PM IST (Indian Standard Time)
  // IST is UTC+5:30, so 10 PM IST = 4:30 PM UTC
  const targetDate = new Date('2026-01-01T16:30:00Z');

  const events = [
    {
      image: images.events.education,
      title: t('home.upcomingEvents.eventTitle'),
      date: t('home.upcomingEvents.date'),
      location: t('home.upcomingEvents.location'),
    },
  ];

  return (
    <div className="events-page">
      <section className="events-hero">
        <div className="container">
          <h1 className="page-title">{t('events.title')}</h1>
        </div>
      </section>

      <section className="events-section">
        <div className="container">
          <h2 className="section-title-large">{t('home.upcomingEvents.title')}</h2>
          <div className="events-list">
            {events.map((event, index) => (
              <div key={index} className="event-card-large">
                <img 
                  src={event.image} 
                  alt={event.title}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = 'https://via.placeholder.com/400x300/f4c430/333333?text=Event';
                  }}
                />
                <div className="event-details-large">
                  <h3>{event.title}</h3>
                  <p className="event-date">🕐 {event.date}</p>
                  <p className="event-location">📍 {event.location}</p>
                  <CountdownTimer targetDate={targetDate} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;

